import React from "react";
import { colors, font } from "../utils/theme.js";

// Client tier, set from the Ops Planner. Tier 1 stands out; Tiers 2 and 3 are equal in
// significance (different kinds of projects), so they share one style; Tier 4 is quietest.
// No tier → no badge.
export const TIERS = [1, 2, 3, 4];
const STYLE = {
  1: { background: colors.accent, color: "#fff", border: colors.accent },
  2: { background: colors.accentDim, color: colors.accent, border: colors.accent },
  3: { background: colors.accentDim, color: colors.accent, border: colors.accent },
  4: { background: "transparent", color: colors.textDim, border: colors.border },
};

export default function TierBadge({ tier, style }) {
  const s = STYLE[tier];
  if (!s) return null;
  return (
    <span title={`Tier ${tier}`} style={{ display: "inline-block", fontSize: 10, fontWeight: 700, lineHeight: "14px", padding: "0 5px", borderRadius: 4, fontFamily: font, background: s.background, color: s.color, border: `1px solid ${s.border}`, ...style }}>
      T{tier}
    </span>
  );
}
